import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/deploy-logs.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-staging',
  templateUrl: './staging.component.html',
  styleUrls: ['./staging.component.scss']
})
export class StagingComponent implements OnInit {

  stagingScripts = [
    {name: 'Reseed', link: '/staging'},
    {name: 'Re deploy API Server', link: '/deploy-staging'},
    {name: 'Reload Seed from S3', link: '/reload-staging-seed'},
    {name: 'Update Seed on S3', link: '/update-staging-seed-s3'},
    {name: 'Pause RDS Instance', link: '/pause-rds-staging'},
    {name: 'Resume RDS Instance', link: '/resume-rds-staging'},
    {name: 'Get RDS Status', link: '/rds_status_staging'},
    {name: 'Seed Customer Tasks', link: '/seed-staging-customer-tasks'},
    {name: 'Seed Business Tasks', link: '/seed-staging-business-tasks'},
    {name: 'Turn demo wall on', link: '/set-staging-demo-page-true'},
    {name: 'Turn demo wall off', link: '/set-staging-demo-page-false'},
    {name: 'Get Deploy Logs', link: '/get-staging-deploy-logs'},
    {name: 'Get Web Build Logs', link: '/get-build-logs?name=bizzycar-staging-web-v2'},
  ]

  showAuthModal = false;
  showResponseModal = false;
  currentEndpoint = '';
  currentScriptName = '';
  responseData: SafeHtml = '';
  isLoading = false;
  error = '';
  username = '';
  password = '';

  constructor(
    private apiService: ApiService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
  }

  executeScript(script: any) {
    this.currentEndpoint = script.link;
    this.currentScriptName = script.name;
    this.showResponseModal = true;
    this.isLoading = true;
    this.error = '';
    this.responseData = '';

    this.apiService.makeApiCall(this.currentEndpoint).subscribe({
      next: (response) => {
        this.responseData = this.sanitizer.bypassSecurityTrustHtml(response);
        this.isLoading = false;
      },
      error: (err) => {
        this.error = 'Failed to execute script. Please try logging out and back in. Check slack #aws-chatbot to confirm the script didnt run before retrying';
        this.isLoading = false;
      }
    });
  }

  closeResponseModal() {
    this.showResponseModal = false;
    this.currentEndpoint = '';
    this.currentScriptName = '';
    this.responseData = '';
    this.error = '';
  }

  copyResponse() {
    // Get the text content from the response div
    const responseElement = document.querySelector('.response-content div');
    if (responseElement) {
      const textToCopy = responseElement.textContent || '';
      if ((navigator as any).clipboard && window.isSecureContext) {
        (navigator as any).clipboard.writeText(textToCopy).then(() => {
          // Optional: Show a success message
          const copyButton = document.querySelector('.copy-button');
          if (copyButton) {
            const originalText = copyButton.innerHTML;
            copyButton.innerHTML = '<span class="copy-icon">✓</span> Copied!';
            setTimeout(() => {
              copyButton.innerHTML = originalText;
            }, 2000);
          }
        }).catch(err => {
          console.error('Failed to copy text: ', err);
        });
      } else {
        // Fallback for non-secure contexts
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          const copyButton = document.querySelector('.copy-button');
          if (copyButton) {
            const originalText = copyButton.innerHTML;
            copyButton.innerHTML = '<span class="copy-icon">✓</span> Copied!';
            setTimeout(() => {
              copyButton.innerHTML = originalText;
            }, 2000);
          }
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
        textArea.remove();
      }
    }
  }

  updateAPIBranchName(name: string) {
    this.currentEndpoint = `/update-staging-api-branch?name=${name}`;
    this.currentScriptName = 'Update API Branch Name';
    this.executeScript({ link: this.currentEndpoint, name: this.currentScriptName });
  }

  updateWEBBranchName(name: string) {
    this.currentEndpoint = `/update-staging-web-branch-name?name=${name}`;
    this.currentScriptName = 'Update WEB Branch Name';
    this.executeScript({ link: this.currentEndpoint, name: this.currentScriptName });
  }

  runCommand(command: string) {
    this.currentEndpoint = `/run-command-on-staging?name=${command}`;
    this.currentScriptName = 'Run Command';
    this.executeScript({ link: this.currentEndpoint, name: this.currentScriptName });
  }
}
